module.exports = __webpack_public_path__ + "static/media/corporate_information.23e83c89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/corporate_information.svg
// module id = 1092
// module chunks = 36